import * as React from 'react';
import {Reporter} from '../core/reporter';
import {AnalyticsContext} from './createAnalyticsContext';

export const createAnalyticsProvider = <T extends string>(
  analyticsReporter: Reporter<T>,
  Context: React.Context<AnalyticsContext<T>>,
) => {
  return ({children}: {children: React.ReactNode}) => {
    return (
      <Context.Provider value={{analyticsReporter}}>
        {children}
      </Context.Provider>
    );
  };
};
